// extracted by mini-css-extract-plugin
export default {"SwitchWithLabel":"SwitchWithLabel_SwitchWithLabel__ATUHy","small":"SwitchWithLabel_small__wx8MZ","clickable":"SwitchWithLabel_clickable__5Wl2G"};